import ArrowSquareUpFill from './ArrowSquareUpFill';

export default ArrowSquareUpFill;
